CardView = require 'views/card/card-view'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class MemberCardsCardView extends View
  initialize: ({ @showBoard }) ->
    @cardView = @subview CardView, @model,
      filterDeactivated: false
      showMemberStatus: false

  className: 'card-grid-container'

  render: ->
    data =
      listName: @model.getList().get('name')
      boardName: @model.getBoard().get('name')
      showBoard: @showBoard

    @$el.html(
      templates.fill(
        'member_cards_card',
        data
      )
    )

    @appendSubview(@cardView, @$('.js-card'))

    @



// WEBPACK FOOTER //
// ./app/scripts/views/card/member-cards-card-view.coffee